import * as actionTypes from '../../../constants';

export function backToFirstPage(payload, cb) {
    return {
        type: actionTypes.BACK_TO_FIRST_PAGE,
        payload
    };
};